export default __webpack_public_path__ + "assets/images/e13dcc573ce94dddec10c9be76d524b2.png";